import { useContext } from 'react';

import { HabitFormContext } from './habit-form-context';

export const useOpenEditHabitDialog = () => {
  const { onEditHabit } = useContext(HabitFormContext);

  return onEditHabit;
};
